export default {
  serviceTitle: '用户服务协议',
  service01: '提示：在使用本产品和服务之前，您应当认真阅读并遵守《用户服务协议》（以下简称“本协议”）和',
  service02: '《隐私保护政策》',
  service03: '。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、争议解决和法律适用条款。',
  service04: '当您按照页面提示阅读并同意本协议后，即表示您已充分理解并接受本协议的全部内容，本协议即产生法律约束力。',
  service05: '一、缔约主体',
  service06: '本协议由通过网站、移动端和桌面端应用软件、硬件以及其他方式使用我们服务的用户（以下简称“用户”或“您”）与{company}（以下简称“我们”或“公司”）共同缔结。',
  service07: '二、协议内容和效力',
  service08: '1、本协议内容包括本协议正文和所有我们已经发布或将来可能发布的各项政策、规则、声明、通知、警示、提示和说明（以下简称“规则”）。前述规则为本协议不可分割的组成部分，与本协议具有同等法律效力。',
  service09: '2、我们有权根据需要不时制订、修改本协议和相关规则，变更后的协议和规则将取代原协议和规则生效。如您不同意相关变更，应当立即停止使用我们的服务，如您继续使用我们的服务或进行任何网站活动，即表示您已接受经修订的协议和规则。',
  service10: '三、服务内容',
  service11: '1、我们的产品和服务包括官网、移动客户端和桌面客户端。本协议不适用于其他第三方通过前述网页或客户端直接向您提供的服务（统称“第三方服务”）。',
  service12: '2、我们有权自行决定对服务或服务的任何部分及其相关功能进行变更、升级、修改和转移。',
  service13: '四、账号管理',
  service14: '1、您在使用我们的服务时，可能需要注册一个账号。您确认，在您完成注册账号并实际使用我们的服务时，应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用我们的服务，否则您和您的监护人应承担因此而导致的一切后果，且我们有权注销（永久冻结）您的账户，并向您和您的监护人索偿。如您代表一家企业、组织机构或其他法律主体进行注册或以其他我们允许的方式实际使用本服务，则您声明和保证，您已经获得充分授权并有权代表该公司、组织机构或法律主体注册使用我们的服务，并接受本协议的约束。',
  service15: '2、您在使用我们的服务时，应当遵守法律法规，不得利用我们的服务从事违法犯罪活动，不得利用我们的服务侵犯他人合法权益。',
  service16: '3、您了解并同意，您注册的账号（包括客户端账号和服务管理账号）所有权归属于我们，注册完成后，您仅获得账号使用权。账号使用权仅归属于初始申请注册人，不得以任何方式转让或提供给他人使用，否则，我们有权不经通知立即收回该账号，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。',
  service17: '五、联系我们',
  service18: '如果有任何疑问、意见或请求，你可以将相关问题发送至',
  service19: '。一般情况下，我们会在收到你相关联系信息并核实你身份后的十五个工作日内回复。',
  service20: '对于与你的身份不直接关联的信息、无效重复信息，或者需要过多技术手段、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。',
  personalInformationTitle: '个人信息收集清单',
  personalInformation01: '我们会收集你在使用服务时主动提供的、通过自动化手段收集的你在使用功能或接受服务过程中产生的下述信息。',
  personalInformation02: '温馨提示：我们会基于向您提供更稳定丰富的产品及服务、维护本服务的正常安全运行、优化本服务的功能体验，处理您在使用相关服务或功能时的个人信息。在为您提供产品及服务的过程中，由于您选择的功能范围及软件版本的不同等原因，收集和处理个人信息的范围可能会有所不同，请以具体的服务或功能为准。个人信息的收集处理详情可参阅',
  personalInformation03: '《隐私保护政策》',
  personalInformation04: '。',
  personalInformationTable01: '可能收集个人信息的场景',
  personalInformationTable02: '可能会收集的个人信息',
  personalInformationTable03: '个人信息的使用目的',
  personalInformationTable04: '账号',
  personalInformationTable05: '手机号码',
  personalInformationTable06: '密码',
  personalInformationTable07: '邮箱',
  personalInformationTable08: '用于注册和登录',
  personalInformationTable09: '头像',
  personalInformationTable10: '性别',
  personalInformationTable11: '出生日期',
  personalInformationTable12: '用于用户自行填写的个人资料',
  personalInformationTable13: '搜索',
  personalInformationTable14: '搜索关键字',
  personalInformationTable15: '用于展示搜索结果和搜索记录',
  personalInformationTable16: '运营与安全保障',
  personalInformationTable17: '设备型号和设置',
  personalInformationTable18: '操作系统版本和设置',
  personalInformationTable19: '设备名称、时区和配置',
  personalInformationTable20: '设备标识符',
  personalInformationTable21: '网络设备硬件 MAC 地址',
  personalInformationTable22: '硬件序列号（SN）',
  personalInformationTable23: 'IP 地址',
  personalInformationTable24: 'WLAN 接入点',
  personalInformationTable25: '蓝牙和基站',
  personalInformationTable26: '软件版本号',
  personalInformationTable27: '网络接入方式、类型和质量',
  personalInformationTable28: '服务日志',
  personalInformationTable29: '应用信息、使用情况、使用频率、崩溃情况、性能数据',
  personalInformationTable30: 'MAC 地址和硬件序列号（SN）由集成的第三方广告 SDK 收集和使用，用于广告效果统计与归因；其他信息用于保障运营与使用安全，提供服务质量和效率',
  openSourceTitle: '开源组件版权信息',
  openSourceTable01: '组件名称',
  openSourceTable02: '版权信息',
  openSourceTable03: '是否经过修改',
  openSourceTable04: '是',
  openSourceTable05: '否',
  authorizationTitle: '权限使用规则',
  authorization01: '为了保障产品功能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限。为了保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理。',
  authorization02: '根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况。如果您想要知悉我们如何收集、使用、存储、分享和转让用户信息，以及我们如何保护用户信息，请查阅',
  authorization03: '《隐私保护政策》',
  authorization04: '。',
  authorizationTable01: '权限名称',
  authorizationTable02: '权限说明',
  authorizationTable03: '使用场景或目的',
  privacySummaryTitle: '隐私政策摘要',
  privacySummaryTitle01: '一、我们如何收集和使用用户信息',
  privacySummaryTitle02: '二、权限使用说明',
  privacySummaryTitle03: '三、涉及收集用户信息的第三方 SDK 信息说明',
  privacySummaryTitle04: '四、管理您的个人信息',
  privacySummary01: '{company}（简称“我们”）深知个人信息安全和隐私保护非常重要，本摘要将帮助您直观、简洁地了解我们是如何收集、处理使用个人信息以及如何保护您的隐私。更多完整、详细信息请阅读完整的',
  privacySummary02: '《隐私保护政策》',
  privacySummary03: '。',
  privacySummary04: '1、账号注册：您在使用我们的服务时，可能需要注册一个账号。我们会收集您的账号和密码以便注册和登录。',
  privacySummary05: '2、使用信息：我们会收集您使用服务时提交或产生的信息。',
  privacySummary06: '3、设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息。',
  privacySummary07: '4、日志信息： 当您使用我们提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。',
  privacySummary08: '5、安全保障： 为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，我们可能使用或整合您的设备信息、软件使用信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，用于进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。',
  privacySummary09: '为了向您提供服务、保障服务的正常运行以及保障您的账号安全，我们需要根据您所使用的服务场景，在征得您同意后向您索取位置、存储、相机、麦克风、通讯录等相关权限。',
  privacySummary10: '为了保障我们的服务稳定运行或实现相关功能，我们可能会接入由第三方提供的软件开发包（SDK）实现前述目的。我们会尽到审慎义务，对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。',
  privacySummary11: '如果您在使用我们的服务时，已经注册了一个账号。您可以提交注销账号申请。在您申请注销账号之前，请确认您的账号钱包无余额，注销账号的申请提交成功之后，管理员会对您的账号进行相关处理。管理员处理您的账号之前，您仍然可以正常登录。',
  thirdPartyTitle: '接入合作方目录',
  thirdPartyTitle01: '穿山甲',
  thirdPartyTitle02: 'AdMob',
  thirdParty01: '为了保障相关功能的实现与应用安全稳定的运行，我们可能会接入由合作方提供的软件开发包（SDK）、应用程序接口（API）、应用程序插件等代码或通过其他合作方式，以实现相关目的。我们会对获取信息的合作方的代码进行严格的安全监测，以保护数据安全。',
  thirdParty02: '我们对接入的相关合作方在下面的目录中列明，合作方具体的处理情况请参见合作方的隐私政策或服务协议。请注意，合作方的代码可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。',
  thirdParty03: '功能：用于移动端展示广告',
  thirdParty04: '收集个人信息类型：设备信息、网络信息、应用信息、传感器信息、广告信息、设备联网标识 MAC 地址、软件安装列表、位置信息和性能数据',
  thirdParty05: '隐私政策链接：https://www.csjplatform.com/privacy/partner',
  thirdParty06: '第三方主体：北京巨量引擎网络技术有限公司',
  thirdParty07: '功能：用于移动端展示广告',
  thirdParty08: '收集个人信息类型：设备识别码、移动广告标识符、设备联网标识 MAC 地址、软件安装列表和位置信息',
  thirdParty09: '隐私政策链接：https://policies.google.com/privacy',
  thirdParty10: '第三方主体：Google LLC',
  privacyTitle: '隐私保护政策',
  privacyTitle01: '1. 本服务如何收集和使用个人信息',
  privacyTitle0101: '1.1. 账号服务',
  privacyTitle0102: '1.2. 搜索',
  privacyTitle0103: '1.3. 安全运营',
  privacyTitle0104: '1.4. 复制与分享',
  privacyTitle0105: '1.5. 用户反馈',
  privacyTitle0106: '1.6. 收集、使用个人信息目的变更',
  privacyTitle0107: '1.7. 征得授权同意的例外',
  privacyTitle02: '2. 我们如何使用Cookie和同类技术',
  privacyTitle03: '3. 数据处理过程中涉及的合作方以及转移、公开个人信息',
  privacyTitle0301: '3.1. 数据处理过程中涉及的合作方',
  privacyTitle0302: '3.2. 转移',
  privacyTitle0303: '3.3. 公开',
  privacyTitle0304: '3.4. 依法豁免征得同意提供、公开的个人信息',
  privacyTitle04: '4. 我们如何存储个人信息',
  privacyTitle0401: '4.1. 存储地点',
  privacyTitle0402: '4.2. 存储期限',
  privacyTitle05: '5. 我们如何保护个人信息的安全',
  privacyTitle06: '6. 管理你的个人信息',
  privacyTitle0601: '6.1. 设置管理',
  privacyTitle0602: '6.2. 意见反馈和投诉举报',
  privacyTitle0603: '6.3. 访问隐私政策',
  privacyTitle0604: '6.4. 停止运营并向你公告',
  privacyTitle07: '7. 未成年人条款',
  privacyTitle08: '8. 隐私政策的修订和通知',
  privacyTitle09: '9. 联系我们',
  privacyTitle10: '10. 其他',
  privacy00: '更新日期：2025年01月25日',
  privacy01: '{company}（以下简称“我们”）作为本产品及服务的运营者，深知个人信息对你的重要性，我们将按照法律法规的规定，保护你的个人信息及隐私安全。我们制定本隐私政策并希望提示你了解下述内容，以便作出适当选择。',
  privacy02: '本隐私政策写明了在不同场景下我们处理你的个人信息的方式，为了帮助你更加直观、简明地了解我们如何收集、使用以及保护你的个人信息，我们也为你提供了内容更加简洁的',
  privacy03: '《隐私政策摘要》',
  privacy04: '，该指引为本隐私政策的一部分。',
  privacy05: '当你开启相关功能、使用相关服务时，我们会收集相关信息。除非是为实现产品功能或根据法律法规要求所必需的信息，你均可以拒绝提供且不影响其他功能或服务，详情可以通过',
  privacy06: '《个人信息收集清单》',
  privacy07: '查阅。',
  privacy08: '通讯录、精确地理位置、麦克风、相机、相册、日历权限等均不会默认开启，只有经过你的明示授权才会在实现特定功能或服务时使用，你也可以撤回授权。特别需要指出的是，即使经过了你的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时收集这些信息，详情可以通过',
  privacy09: '《权限使用规则》',
  privacy10: '查阅。',
  privacy11: '本隐私政策适用于我们的产品及服务，包括客户端应用程序、小程序、官方网站和其他由我们提供且使用本隐私政策的所有产品及服务（以下统称“本服务”）。本隐私政策不适用于其他第三方向你提供的服务，你在选择使用第三方服务前应充分了解第三方服务的产品功能及隐私保护政策，再选择是否使用相应功能或服务。',
  privacy12: '除本隐私政策外，在特定场景下，我们还会通过即时告知（含弹窗、页面提示等）、功能更新说明等方式，向你说明对应的信息收集目的、范围及使用方式，这些即时告知及功能更新说明等构成本隐私政策的一部分，并与本隐私政策具有同等效力。',
  privacy13: '下文将帮你详细了解我们如何收集、使用、存储、转移（如适用）与保护你的个人信息。并且帮你了解查询、复制、删除、更正、撤回授权个人信息的方式。本政策与你使用我们的服务关系密切，我们建议你仔细阅读并理解本政策全部内容，作出你认为适当的选择。',
  privacy14: '为了向你提供本服务、维护本服务的正常安全运行、优化本服务的功能体验，我们会按照如下目的与方式，收集你在使用本服务时主动提供、授权提供的个人信息，以及你使用本服务时产生的个人信息：',
  privacy16: '你可以根据自己的需求，自主填写或设置头像、个性签名、个人状态等信息，这些你主动填写或设置的个人资料将用于向其他用户展示。不填写或设置这些信息不影响你使用我们的服务。',
  privacy17: '你使用搜索功能时，我们会收集你的搜索关键字信息、日志记录，以便向你展示搜索结果内容、搜索历史记录。搜索关键字信息会同时存储在你的设备和我们的服务端，你可以点击搜索框，查看和删除对应存储在本设备和服务端的搜索历史关键字。',
  privacy18: '我们致力于为你提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为了维护我们服务的正常运行，保护你或其他用户或公众的合法利益免受损失，我们会收集用于维护产品或服务安全稳定运行的必要信息。',
  privacy19: '为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的：硬件型号、操作系统版本号、设备标识符、软件安装列表、IP 地址、WLAN 接入点、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备时区、设备名称、CPUID、主板序列号、硬盘序列号。为了进行广告效果统计与归因，本服务集成的第三方广告 SDK 会收集和使用你的网络设备硬件地址（设备 MAC 地址）、硬件序列号（SN）。',
  privacy20: '为了预防恶意程序、保障运营质量及效率，我们会收集你安装的应用信息（如版本、语言、来源等）、进程信息、总体运行、使用情况与频率、应用崩溃情况、性能数据。',
  privacy21: '我们可能使用你的账号信息、设备信息、服务日志信息以及我们关联方、合作方在获得你授权或依法可以提供的信息，用于判断账户及交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。',
  privacy22: '在你分享、复制信息时，我们需要访问你的剪切板，读取其中包含的口令、分享码、链接及其他内容信息，以实现跳转、复制、分享等功能或服务。',
  privacy23: '在使用本服务过程中，你可以对使用过程中遇到的问题及服务体验进行问题反馈，帮助我们更好地了解你使用我们产品或服务的体验和需求，在帮你解决问题的同时，帮助我们改善产品和服务，为此我们会记录你的联系信息、反馈的问题或建议、你与我们的通信/通话记录及相关内容，以便我们进一步联系你，向你反馈我们的处理进度。',
  privacy24: '请你了解，随着我们业务的发展，可能会对我们的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用你的个人信息，会再次按照法律法规及国家标准的要求以页面提示、交互流程、协议确认等合理的方式另行向你进行告知说明，并征得你的同意。',
  privacy25: '请你理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用你的个人信息无需征得你的授权同意：',
  privacy26: '与我们履行法律法规规定的义务相关的；',
  privacy27: '与国家安全、国防安全直接相关的；',
  privacy28: '与公共安全、公共卫生、重大公共利益直接相关的；',
  privacy29: '与犯罪侦查、起诉、审判和判决执行等直接相关的；',
  privacy30: '出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
  privacy31: '所收集的你的个人信息是你自行向社会公众公开的；',
  privacy32: '从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开等渠道；',
  privacy33: '根据你的要求签订或履行合同所必需的；',
  privacy34: '用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；',
  privacy35: '为合法的新闻报道所必需的；',
  privacy36: '学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
  privacy37: '法律法规规定的其他情形。',
  privacy38: '我们使用Cookie和其他类似技术，以提升你使用本服务的体验。当你使用本服务时，我们可能会使用相关技术向你的设备发送一个或多个 Cookie 或匿名标识符，以收集和存储你访问、使用本服务时的信息。我们承诺，不会将 Cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用 Cookie 和同类技术主要为了实现以下功能或服务：',
  privacy39: '保障产品与服务的安全、高效运转：我们可能会设置认证与保障安全性的 Cookie 或匿名标识符，使我们确认你是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度；',
  privacy40: '帮助你获得更轻松的访问体验：使用此类技术可以帮助你省去重复你填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。',
  privacy41: '大多数浏览器均为用户提供了清除浏览器缓存数据的功能，你可以在浏览器设置功能中进行相应的数据清除操作。如你进行清除，你可能无法使用由我们提供的、依赖于 Cookie 的服务或相应功能。',
  privacy42: '与合作方合作过程中涉及数据使用活动的，必须具有合法目的、符合法定的合法性基础。如果合作方使用信息不再符合合法原则，则其不应再使用你的个人信息，或在获得相应合法性基础后再行使用。',
  privacy43: '我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全，详情可以通过',
  privacy44: '《接入合作方目录》',
  privacy45: '查阅。',
  privacy46: '随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，你的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所要求的安全标准继续保护或要求个人信息的继受方继续保护你的个人信息，否则我们将要求继受方重新征得你的授权同意。',
  privacy47: '我们不会公开你的信息，除非遵循国家法律法规规定、基于你的主动选择或者获得你的同意。我们公开你的个人信息会采用符合行业内标准的安全保护措施。',
  privacy48: '请你理解，在下列情形中，根据法律法规及国家标准，我们向合作方或第三方提供、公开你的个人信息无需征得你的授权同意：',
  privacy49: '与我们履行法律法规规定的义务相关的；',
  privacy50: '与国家安全、国防安全直接相关的；',
  privacy51: '与公共安全、公共卫生、重大公共利益直接相关的；',
  privacy52: '与犯罪侦查、起诉、审判和判决执行等直接相关的；',
  privacy53: '出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
  privacy54: '所收集的你的个人信息是你自行向社会公众公开的；',
  privacy55: '从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开等渠道；',
  privacy56: '根据你的要求签订或履行合同所必需的；',
  privacy57: '用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；',
  privacy58: '为合法的新闻报道所必需的；',
  privacy59: '学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
  privacy60: '法律法规规定的其他情形。',
  privacy61: '我们依照法律法规的规定，将在境内运营过程中收集和产生的你的个人信息存储于中华人民共和国境内。目前，我们不会将你的个人信息传输至境外，如果基于满足管理需要向境外传输，我们将会遵循相关国家规定保护你的个人信息。',
  privacy62: '你在使用本服务期间，我们将持续保存你的个人信息，保存期限将以不超过提供服务所必须的期间为原则。如我们停止运营本服务、你主动删除个人信息或超出必要期间后，我们将在合理期限内依照所适用的法律对所持有的你的个人信息进行删除或匿名化处理。但以下情况除外：',
  privacy63: '遵从法律法规有关信息留存的要求（例如：《网络安全法》规定：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月）。',
  privacy64: '出于财务、审计、争议解决等目的需要合理延长期限的。',
  privacy65: '我们非常重视你个人信息的安全。目前，我们基于适用的法律法规要求，建立了高标准的个人信息保护管理体系，并实施了安全技术措施来确保个人信息处理全生命周期中的安全性与合规性，充分保障用户隐私。我们的网络服务采取了传输层安全协议等加密技术，确保你的数据在网络传输过程的安全。',
  privacy66: '我们采用严格的数据处理权限控制，避免数据被违规使用。我们采用打码屏蔽等去标识化技术的多种数据脱敏方式增强个人信息在使用中的安全性。同时，我们采用行业广泛应用的加密技术对你的个人信息进行加密保存，并通过数据隔离技术进行隔离，并可能不时加以修订完善以提升系统的整体安全性。',
  privacy67: '尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请你理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保你提供给我们的个人信息的安全性。请你知悉并理解，你接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议你采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。',
  privacy68: '在我们获悉发生了你的个人信息不幸被泄露、非法提供或滥用的个人信息安全事件后，我们将按照法律法规的要求及时向你告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、你可自主防范和降低风险的建议、对你的补救措施等。事件相关情况我们将以推送通知的方式告知你，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。',
  privacy69: '你一旦浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护你在使用第三方产品过程中提交的任何个人信息，无论你登录、浏览或使用上述软件、网站是否基于本服务的链接或引导。',
  privacy70: '我们非常重视你对个人信息的管理，并尽全力保护你对于你个人信息的查阅、复制、更正、补充、删除、撤回同意授权、投诉举报以及设置隐私功能等权利，以使你有能力保障你的隐私和信息安全。',
  privacy71: '但请你理解，特定的业务功能和服务将需要你的信息才能得以完成，当你撤回同意或授权后，我们无法继续为你提供对应的功能和服务，也不再处理你相应的个人信息。但你撤回同意或授权的决定，不会影响我们此前基于你的授权而开展的个人信息处理。',
  privacy72: '我们在不同的版本或操作系统中提供的管理方式的路径可能会有差异，请以实际为准。',
  privacy73: '你可以直接在设备操作系统中自主开启或关闭相关系统权限，改变同意范围或撤回你的授权。撤回授权后我们将不再收集与该权限相关信息。本服务通过穿山甲（CSJ）广告 SDK 提供个性化广告推荐（个性化推送）功能，根据你的设备信息、广告浏览和点击等操作信息分析你的偏好，向你展示可能感兴趣的广告。“个性化广告”开关默认开启，你可以随时进入应用内“设置”页面，关闭“个性化广告”开关。关闭后，将停止向你提供个性化广告推荐，但你仍可能看到非个性化广告，且不影响你使用应用的其他功能。',
  privacy75: '如果你有任何意见或你认为你的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，你可以通过本隐私政策公布的联系方式与我们联系。',
  privacy76: '你可以在启动页面或者设置页面查看本隐私政策的全部内容。',
  privacy77: '请你了解，本隐私政策中所述的本服务的相关功能可能会根据你所使用的设备型号、系统版本、软件应用程序版本等因素而有所不同。最终的产品和服务以你所使用的软件及相关服务为准。',
  privacy78: '如我们停止运营，我们将及时停止收集你个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知你，并对所持有的你的个人信息进行删除或匿名化处理。',
  privacy79: '若你是未满18周岁的未成年人，在使用本服务前，应在你的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。',
  privacy80: '若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。',
  privacy81: '为了给你提供更好的服务，本服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经你明确同意，我们不会削减你依据当前生效的本隐私政策所应享受的权利。',
  privacy82: '本隐私政策更新后，我们会发出更新版本，并在更新后的条款生效前通过适当的方式提醒你更新的内容，以便你及时了解本隐私政策的最新版本。如果你在本隐私政策更新之后继续使用本服务，即视为你接受更新后的隐私政策。',
  privacy83: '与本隐私政策相关的任何疑问、意见或请求，你可以将相关问题发送至',
  privacy84: '。一般情况下，我们会在收到你相关联系信息并核实你身份后的十五个工作日内回复。',
  privacy85: '对于与你的身份不直接关联的信息、无效重复信息，或者需要过多技术手段、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。',
  privacy86: '本隐私政策可能存在多种语言版本，如各语言版本条款出现不一致或冲突，以本隐私政策中文简体版本为准。',
  privacy87: '本隐私政策中的标题仅为方便及阅读而设，并不影响本隐私政策中任何规定的含义或解释。',
}
